const translations = {
  "en": {
    "Check your brokerage connection, then try again.": "Check your brokerage connection, then try again.",
    "I couldn’t read your holdings yet.": "I couldn’t read your holdings yet.",
    "I’ll check which of your funds overlap as soon as the account is ready.": "I’ll check which of your funds overlap as soon as the account is ready.",
    "I’ll compare what you hold with your ranking as soon as the account is ready.": "I’ll compare what you hold with your ranking as soon as the account is ready.",
    "Reading your holdings…": "Reading your holdings…",
    "Try again": "Try again"
  },
  "zh-tw": {
    "Check your brokerage connection, then try again.": "請檢查券商帳戶的連線，再試一次。",
    "I couldn’t read your holdings yet.": "我暫時還無法讀取你的持倉。",
    "I’ll check which of your funds overlap as soon as the account is ready.": "帳戶就緒後，我會立即為您檢查基金的重疊情形。",
    "I’ll compare what you hold with your ranking as soon as the account is ready.": "帳戶準備好後，我就會將你的持倉與這份榜單對照。",
    "Reading your holdings…": "正在讀取你的持倉…",
    "Try again": "重試"
  }
};

export default translations;
